import React from "react";

// PROJECT IMAGES (NAMED)
import AlltraLaunchImg from "../../images/project/project/Alltra Launch.png";
import BlueLotusDAOImg from "../../images/project/project/Blue Lotus DAO.png";
import CofinexImg from "../../images/project/project/Cofinex.png";
import MIEXSSwapImg from "../../images/project/project/MIEXS Swap.png";


// PROJECT BG IMAGES
import h2cryptoImg from "../../images/project/projectBG/h2crypto.png";
import pantherImg from "../../images/project/projectBG/panther.png";
import tradiumImg from "../../images/project/projectBG/tradium.png";
import zurumiImg from "../../images/project/projectBG/zurumi.png";


// ARROW ICON SVG (UNCHANGED)
const ArrowIcon = () => (
  <>
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none">
      <rect x="5.23" y="17.32" width="17.88" height="2.27" transform="rotate(-40.28 5.23 17.32)" fill="white" />
      <rect x="7.75" y="6.25" width="2.27" height="2.27" transform="rotate(-40.28 7.75 6.25)" fill="white" />
      <rect x="10.95" y="6.52" width="2.27" height="2.27" transform="rotate(-40.28 10.95 6.52)" fill="white" />
      <rect x="14.16" y="6.78" width="2.27" height="2.27" transform="rotate(-40.28 14.16 6.78)" fill="white" />
      <rect x="17.09" y="10.25" width="2.27" height="2.27" transform="rotate(-40.28 17.09 10.25)" fill="white" />
      <rect x="16.83" y="13.45" width="2.27" height="2.27" transform="rotate(-40.28 16.83 13.45)" fill="white" />
      <rect x="16.56" y="16.65" width="2.27" height="2.27" transform="rotate(-40.28 16.56 16.65)" fill="white" />
    </svg>

    <svg width="25" height="25" viewBox="0 0 25 25" fill="none">
      <rect x="5.23" y="17.32" width="17.88" height="2.27" transform="rotate(-40.28 5.23 17.32)" fill="white" />
      <rect x="7.75" y="6.25" width="2.27" height="2.27" transform="rotate(-40.28 7.75 6.25)" fill="white" />
      <rect x="10.95" y="6.52" width="2.27" height="2.27" transform="rotate(-40.28 10.95 6.52)" fill="white" />
      <rect x="14.16" y="6.78" width="2.27" height="2.27" transform="rotate(-40.28 14.16 6.78)" fill="white" />
      <rect x="17.09" y="10.25" width="2.27" height="2.27" transform="rotate(-40.28 17.09 10.25)" fill="white" />
      <rect x="16.83" y="13.45" width="2.27" height="2.27" transform="rotate(-40.28 16.83 13.45)" fill="white" />
      <rect x="16.56" y="16.65" width="2.27" height="2.27" transform="rotate(-40.28 16.56 16.65)" fill="white" />
    </svg>
  </>
);

// 🔁 PROJECT DATA (REPLACED WITH 8 REAL PROJECTS)
const projectData = [
  {
    title: "H2Crypto",
    content: "A crypto-focused platform delivering secure blockchain-based financial solutions.",
    images: [h2cryptoImg, h2cryptoImg, h2cryptoImg, h2cryptoImg],
    reverse: false,
    link: "http://h2crypto.io/",
  },
  {
    title: "Panther Exchange",
    content: "A next-generation cryptocurrency exchange designed for speed, security, and liquidity.",
    images: [pantherImg, pantherImg, pantherImg, pantherImg],
    reverse: true,
    link: "https://pantherexchange.io/",
  },
  {
    title: "Cofinex",
    content: "A digital asset trading platform offering advanced tools and seamless user experience.",
    images: [CofinexImg, CofinexImg, CofinexImg, CofinexImg],
    reverse: false,
    link: "https://cofinex.io/",
  },
  {
    title: "Zurumi",
    content: "A Web3 ecosystem delivering decentralized applications and next-gen blockchain services.",
    images: [zurumiImg, zurumiImg, zurumiImg, zurumiImg],
    reverse: true,
    link: "https://www.zurumi.com/",
  },
  {
    title: "MIEXS Swap",
    content: "A decentralized swap platform enabling secure and fast token exchanges.",
    images: [MIEXSSwapImg, MIEXSSwapImg, MIEXSSwapImg, MIEXSSwapImg],
    reverse: false,
    link: "https://swap.miexs.com/",
  },
  {
    title: "Blue Lotus DAO",
    content: "A decentralized autonomous organization focused on community-driven governance.",
    images: [BlueLotusDAOImg, BlueLotusDAOImg, BlueLotusDAOImg, BlueLotusDAOImg],
    reverse: true,
    link: "https://bluelotusdao.org/?chain=gsys",
  },
  {
    title: "Alltra Launch",
    content: "A blockchain launchpad enabling projects to raise, launch, and scale efficiently.",
    images: [AlltraLaunchImg, AlltraLaunchImg, AlltraLaunchImg, AlltraLaunchImg],
    reverse: false,
    link: "https://alltralaunch.digital/client/home",
  },
  {
    title: "Tradium Pro",
    content: "A professional trading platform offering advanced analytics and trading tools.",
    images: [tradiumImg, tradiumImg, tradiumImg, tradiumImg],
    reverse: true,
    link: "https://tradiumpro.com/",
  },
];

const ProjectSection: React.FC = () => {
  return (
    <section className="service pos-rel">
      <div className="container mxw-1650">
        <div className="xb-project-wrap xb-project-wrap_2">

          {projectData.map((item, index) => (
            <div className="xb-project-item" key={index}>

              {!item.reverse ? (
                <>
                  <div className="xb-project-content">
                    <div className="xb-item--inner xb-border">
                      <h2 className="xb-item--title">{item.title}</h2>
                      <p className="xb-item--content clr-white">{item.content}</p>

                      <div className="xb-item--btn mt-40">
                        <a className="thm-btn agency-btn" href={item.link} target="_blank" rel="noopener noreferrer">
                          <span className="text">Visit Project</span>
                          <span className="arrow">
                            <span className="arrow-icon"><ArrowIcon /></span>
                          </span>
                        </a>
                      </div>
                    </div>
                  </div>

                  <div className="xb-project-img img-hove-effect">
                    <div className="xb-img">
                      {item.images.map((img, i) => (
                        <a href={item.link} target="_blank" rel="noopener noreferrer" key={i}>
                          <img src={img} alt="project" />
                        </a>
                      ))}
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className="xb-project-img img-hove-effect">
                    <div className="xb-img">
                      {item.images.map((img, i) => (
                        <a href={item.link} target="_blank" rel="noopener noreferrer" key={i}>
                          <img src={img} alt="project" />
                        </a>
                      ))}
                    </div>
                  </div>

                  <div className="xb-project-content">
                    <div className="xb-item--inner xb-border">
                      <h2 className="xb-item--title">{item.title}</h2>
                      <p className="xb-item--content clr-white">{item.content}</p>

                      <div className="xb-item--btn mt-40">
                        <a className="thm-btn agency-btn" href={item.link} target="_blank" rel="noopener noreferrer">
                          <span className="text">Visit Project</span>
                          <span className="arrow">
                            <span className="arrow-icon"><ArrowIcon /></span>
                          </span>
                        </a>
                      </div>
                    </div>
                  </div>
                </>
              )}

            </div>
          ))}

        </div>
      </div>
    </section>
  );
};

export default ProjectSection;
